function asString(value) {
  if (value === null || value === undefined) return "";
  return String(value).trim();
}

function normalizePath(path) {
  const text = asString(path);
  if (!text) return "";
  return text.endsWith("/") ? text : `${text}/`;
}

function startsWithRoute(currentPath, basePath) {
  const current = normalizePath(currentPath);
  const base = normalizePath(basePath);
  if (!current || !base) return false;
  return current === base || current.startsWith(base);
}

export function buildShellModules({ links = [] }) {
  const modules = [];
  const seen = new Set();
  let hasModulesAccess = false;

  const pushModule = (item) => {
    const key = asString(item?.key || item?.path);
    if (!key || seen.has(key)) return;
    seen.add(key);
    modules.push(item);
  };

  pushModule({
    key: "home",
    title: "Inicio",
    path: "/-/",
    isActive: (path) => normalizePath(path) === normalizePath("/-/"),
  });

  (Array.isArray(links) ? links : []).forEach((link) => {
    const path = asString(link?.Path || link?.path);
    if (!path) return;
    if (startsWithRoute(path, "/-/perfil") || startsWithRoute(path, "/perfil")) return;
    const title = asString(link?.Name || link?.name || path);
    const code = asString(link?.Code || link?.code || path);
    const normalizedCode = code.toLowerCase();
    const isModulesRootLink = startsWithRoute(path, "/-/modules");
    if (normalizedCode === "modules" || isModulesRootLink) {
      hasModulesAccess = true;
    }
    pushModule({
      key: code,
      title,
      path,
      isActive: (pathValue) => {
        if (!isModulesRootLink) return startsWithRoute(pathValue, path);
        return startsWithRoute(pathValue, "/-/modules") && !startsWithRoute(pathValue, "/-/modules/catalog");
      },
    });
  });

  if (hasModulesAccess) {
    pushModule({
      key: "modules-menu",
      title: "Menú",
      path: "/-/modules/catalog?tab=apps",
      isActive: (pathValue) => startsWithRoute(pathValue, "/-/modules/catalog"),
    });
  }

  return modules;
}

export function resolveActiveModuleKey(modules, currentPath, requestURI) {
  const list = Array.isArray(modules) ? modules : [];
  const found = list.find((item) => {
    if (typeof item?.isActive === "function") {
      return item.isActive(currentPath, requestURI);
    }
    return startsWithRoute(currentPath, item?.path);
  });
  if (found?.key) return found.key;
  return list[0]?.key || "";
}
